import { createFileRoute } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import { PublicLayout } from "~/components/public/public-layout";
import { Card } from "~/components/ui/card";

export const Route = createFileRoute("/enquire/thanks")({
  component: ThanksPage,
});

function ThanksPage() {
  return (
    <PublicLayout narrow>
      <Card className="flex flex-col items-center gap-4 px-6 py-12 text-center">
        <span className="grid size-14 place-items-center rounded-full bg-success-soft text-success">
          <CheckCircle2 className="size-7" aria-hidden />
        </span>
        <h1 className="text-h1 text-fg">Thanks, we've got your enquiry</h1>
        <p className="max-w-md text-body text-fg-secondary">
          Someone from the Purlink team will be in touch soon, usually within one working day.
          There's nothing else you need to do.
        </p>
      </Card>
    </PublicLayout>
  );
}
